"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VehicleGroups = function () {
  function VehicleGroups($q, API) {
    _classCallCheck(this, VehicleGroups);

    this.$q = $q;
    this.API = API;
  }

  _createClass(VehicleGroups, [{
    key: "getVehicleGroups",
    value: function getVehicleGroups(vehicleIds, groupIds, searchTerm, paging) {
      var targetAccount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var deferred = this.$q.defer();
      var url = "v1/vehicle-groups";

      var param = [];
      param.push.apply(param, this.API.getPagingQuery(paging));
      param.push.apply(param, this.API.getArrayQuery("vehicleId", vehicleIds));
      param.push.apply(param, this.API.getArrayQuery("groupId", groupIds));
      if (searchTerm) param.push("searchTerm=" + searchTerm);

      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (vehicles) {
        //console.log("vehicle groups: ", vehicles);
        deferred.resolve(vehicles);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getById",
    value: function getById(groupId) {
      var targetAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var deferred = this.$q.defer();
      var url = "v1/vehicle-groups/" + groupId;

      var param = [];
      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (vehicle) {
        return deferred.resolve(vehicle);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return VehicleGroups;
}();

exports.default = VehicleGroups;


VehicleGroups.$inject = ["$q", "FleetPortalAPI"];


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.vehicle-groups.js